import {Platform, StyleSheet, ViewStyle} from 'react-native';

import {indent} from '/constant/layout.constant';

const DOTS_HEIGHT = 38;
const DOT_SIZE = 11;
const DOT_MARGIN = 3;
const MIN_TOUCH_TARGET = 32;
const DOT_BORDER_WIDTH = 2;

const CARD_MIN_HEIGHT = 340;
const PEEK_TOTAL = 80;

export {DOTS_HEIGHT, DOT_SIZE, DOT_MARGIN, MIN_TOUCH_TARGET};

export default StyleSheet.create({
  itemWrapper: {
    width: `calc(100cqw - ${PEEK_TOTAL}px)` as unknown as number,
    minWidth: `calc(100cqw - ${PEEK_TOTAL}px)` as unknown as number,
    flexShrink: 0,
  },
  wrapper: {
    minHeight: CARD_MIN_HEIGHT,
    paddingBottom: DOTS_HEIGHT,
    flexShrink: 0,
    containerType: 'inline-size',
  } as unknown as ViewStyle,
  wrapperNoDots: {
    minHeight: 0,
    paddingBottom: 0,
  } as unknown as ViewStyle,
  contentContainer: {
    paddingLeft: indent,
    paddingRight: indent * 0.75,
    gap: indent,
  },
  imageMask: {
    ...StyleSheet.absoluteFillObject,
  },
  dots: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    width: '100%',
    height: DOTS_HEIGHT,
    justifyContent: 'center',
    flexDirection: 'row',
    pointerEvents: 'box-none',
    zIndex: 1000,
  },
  dotContainer: {
    width: DOT_SIZE,
    height: DOT_SIZE,
    position: 'relative',
    justifyContent: 'center',
    alignItems: 'center',
    marginHorizontal: DOT_MARGIN,
  },
  dotBorder: {
    width: DOT_SIZE,
    height: DOT_SIZE,
    borderRadius: DOT_SIZE / 2,
    borderWidth: DOT_BORDER_WIDTH,
    justifyContent: 'center',
    alignItems: 'center',
  },
  dot: {
    width: DOT_SIZE - DOT_BORDER_WIDTH * 2,
    height: DOT_SIZE - DOT_BORDER_WIDTH * 2,
    borderRadius: (DOT_SIZE - DOT_BORDER_WIDTH * 2) / 2,
  },
  dotButtonFocused: {
    borderWidth: 0,
    borderColor: 'transparent',
    outlineWidth: 0,
    outlineStyle: 'none',
  } as unknown as ViewStyle,
  dotButton: {
    width: Platform.OS === 'ios' ? 48 : MIN_TOUCH_TARGET,
    height: Platform.OS === 'ios' ? 48 : MIN_TOUCH_TARGET,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'transparent',
    pointerEvents: 'auto',
    paddingHorizontal: Platform.OS === 'ios' ? 4 : 0,
    paddingVertical: Platform.OS === 'ios' ? 4 : 0,
    outlineWidth: 0,
    outlineStyle: 'none',
  } as unknown as ViewStyle,
});
